import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n/LanguageContext";

export default function HeroSection() {
  const { t } = useLanguage();

  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20professional%20Hispanic%20window%20repair%20technician%20in%20a%20green%20uniform%20working%20on%20repairing%20a%20residential%20window%20frame%2C%20holding%20tools%20and%20wearing%20a%20tool%20belt%2C%20bright%20daylight%2C%20Miami%20tropical%20home%20exterior%20background%2C%20realistic%20professional%20photography%20style%2C%20warm%20green%20color%20tones%20dominant%2C%20clean%20and%20trustworthy%20look&width=1920&height=900&seq=hero1&orientation=landscape"
          alt={t("home.heroImageAlt") as string}
          className="w-full h-full object-cover object-top"
          width={1920}
          height={900}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-secondary/80 via-secondary/60 to-secondary/40" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6 w-full py-20">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 bg-[#fefce8] px-4 py-2 text-sm font-bold text-secondary mb-6">
            <i className="ri-map-pin-line text-primary" />
            {t("home.eyebrow")}
          </div>
          <h1 className="text-4xl sm:text-5xl md:text-[56px] font-black text-white leading-tight mb-4">
            {t("home.h1")}
            <span className="block italic">{t("home.h1Italic")}</span>
          </h1>
          <p className="text-base md:text-lg text-[#fefce8] leading-relaxed mb-8 max-w-[600px]">
            {t("home.subhead")}
          </p>
          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href="tel:+17863774452"
              className="inline-flex items-center justify-center gap-2 bg-[#ea580c] text-white px-8 py-4 text-sm font-bold rounded-brand hover:bg-[#c2410c] transition-colors whitespace-nowrap w-full sm:w-auto"
            >
              <i className="ri-phone-line" />
              {t("home.ctaPrimary")}
            </a>
            <Link
              to="/legal-disclaimer/"
              className="inline-flex items-center justify-center gap-2 bg-transparent border-2 border-white text-white px-8 py-4 text-sm font-bold rounded-brand hover:bg-white hover:text-secondary transition-colors whitespace-nowrap w-full sm:w-auto"
            >
              <i className="ri-message-3-line" />
              {t("home.ctaSecondary")}
            </Link>
          </div>
          <div className="mt-8 flex flex-wrap items-center gap-4 md:gap-6 text-white text-xs md:text-sm">
            <span className="flex items-center gap-1.5">
              <i className="ri-checkbox-circle-line text-[#047857]" />
              {t("common.sameDay")}
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-checkbox-circle-line text-[#047857]" />
              {t("common.guarantee")}
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-checkbox-circle-line text-[#047857]" />
              {t("common.licensed")}
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-checkbox-circle-line text-[#047857]" />
              {t("home.honestRate")}
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}